import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkText } from "uitk-react-text";
import { UitkSpacing } from "uitk-react-spacing";
import { getRatingText } from "components/utility/Reviews";
import { Hotel } from "typings/microserviceModels/hotels-flex-module";

const GuestRating = (props: { hotel: Hotel; className: string }) => {
  const { formatText } = useLocalization();
  const { hotel, className } = props;
  const { hotelOverallReviewRating, reviewCount } = hotel;

  const numberOfReviewsLocalized = "hotels.review.reviewCount";

  if (!(hotelOverallReviewRating && reviewCount)) {
    return (
      <UitkText size={300} className={className}>
        {formatText(numberOfReviewsLocalized, 0, "0")}
      </UitkText>
    );
  }

  return (
    <UitkText size={300} className={className}>
      <span className="uitk-type-heading-300">
        {formatText("hotelRecentReviews.ratingSlashNoSpace", Math.round(hotelOverallReviewRating))}
      </span>
      <UitkSpacing margin={{ inlinestart: "one" }}>
        <span className="uitk-type-300">
          {getRatingText(hotelOverallReviewRating)} ({formatText(numberOfReviewsLocalized, reviewCount, reviewCount)})
        </span>
      </UitkSpacing>
    </UitkText>
  );
};

export default GuestRating;
